import React from 'react';
import { FiRefreshCcw } from 'react-icons/fi';
import classNames from 'classnames/bind';

import styles from './Exams.module.scss';

const cx = classNames.bind(styles);

function ExamsHeader({ isRefreshing, onRefresh }) {
    return (
        <header className={cx('exams-page__header')}>
            <div>
                <h1>Quản lý đề thi</h1>
                <p>
                    Theo dõi trạng thái của đề thi, kiểm tra tỷ lệ hoàn thành và phối hợp với các bộ phận để đảm bảo kỳ thi diễn ra suôn sẻ.
                </p>
            </div>
            <button
                type="button"
                className={cx('refresh-button')}
                onClick={onRefresh}
                disabled={isRefreshing}
            >
                <FiRefreshCcw size={18} />
                {isRefreshing ? 'Đang tải...' : 'Làm mới'}
            </button>
        </header>
    );
}

export default ExamsHeader;
